/**
 * @module router/guards/auth
 * @description 인증 상태 확인 라우터 가드 — 비로그인 시 /login(또는 스태프팀 로그인)으로 리다이렉트합니다.
 */

/**
 * 인증이 필요한 라우트에 비로그인 상태로 접근할 경우 로그인 페이지로 리다이렉트합니다.
 *
 * @param {import('vue-router').RouteLocationNormalized} to - 이동할 라우트
 * @param {import('vue-router').RouteLocationNormalized} from - 현재 라우트
 * @param {import('vue-router').NavigationGuardNext} next - 다음 라우트 진행 함수
 * @returns {boolean} 리다이렉트가 발생한 경우 true, 통과한 경우 false
 */
export const authGuard = (to, from, next) => {
  const authToken = sessionStorage.getItem('authToken')
  const isStaffTeamPath = to.path.startsWith('/mobile/staff-team')

  if (!authToken && to.meta.authorization === true) {
    next({ path: isStaffTeamPath ? '/mobile/staff-team/login' : '/login' })
    return true
  }
  return false
}
